// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// assets
import useAuth from '@hooks/useAuth';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

export default function Search() {
  const { user } = useAuth();
  const labName = user?.laboratory?.name || user?.labName;
  return (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
      <Typography variant="h4">{labName}</Typography>
      {/* <FormControl sx={{ width: { xs: '100%', md: 224 } }}>
        <OutlinedInput
          size="small"
          id="header-search"
          startAdornment={
            <InputAdornment position="start" sx={{ mr: -0.5 }}>
              <SearchOutlined />
            </InputAdornment>
          }
          aria-describedby="header-search-text"
          slotProps={{ input: { 'aria-label': 'weight' } }}
          placeholder="Ctrl + K"
        />
      </FormControl> */}
    </Box>
  );
}
